export enum EmailNotificationTypes {
  VolunteerOpportunitySearch,
  VolunteerOrganisationViewedEoi,
  OrganisationSummary,
  VolunteerAllOpportunitySearches,
  OrganisationNoActivityForThreeMonths,
  OrganisationNoActivityForOneYear
}
